import ButtonPlay from './ButtonPlay';

export default ButtonPlay;